export const TransactionTypes: any = {
  ACCEPTED: {
    label: 'Accepted'
  },
  CANCELED: {
    label: 'Cancelled'
  },
  REJECTED: {
    label: 'Rejected'
  },
  QUOTED: {
    label: 'Orphan'
  },
  TOTAL: {
    label: 'Total'
  },
  FAILURE: {
    label: 'Failure',
    color: '#FFEB3B'
  },
  SUCCESS: {
    label: 'Success',
    color: '#0CACF3'
  },
  ERROR: {
    label: 'Error',
    color: '#F32A23'
  }
};
